export default function initSingleCareer() {
    // Get all tab buttons and tab items
    var tabBtns = document.querySelectorAll('.tab-btn');
    var tabItems = document.querySelectorAll('.tab-item');

    // Show the first tab by default
    tabBtns[0].classList.add('active');
    tabItems[0].classList.add('active');

    tabBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            // Close all tabs
            tabBtns.forEach(function (tab) {
                tab.classList.remove('active');
            });
            tabItems.forEach(function (item) {
                item.classList.remove('active');
            });

            // Open the clicked tab
            var tabId = btn.getAttribute('data-tab');
            var tabContent = document.getElementById(tabId);

            btn.classList.add('active');
            tabContent.classList.add('active');
        });
    });
}
